/* eslint-disable */
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
// If you need to update this file, make changes in the Core application
// then run `import:api` in your terminal from the root of this project.
//  BaseClient
import axios from 'axios';
import type { AxiosPromise, AxiosRequestConfig, AxiosResponse, AxiosStatic } from 'axios';

type NodeEnvironment = 'development' | 'local' | 'onboarding' | 'production' | 'staging' | 'test';
type APIRequest = (payload: SendRequestPayload) => AxiosPromise;
type Method = 'DELETE' | 'GET' | 'OPTIONS' | 'PATCH' | 'POST' | 'PUT';
interface RequestPayload {
  data?: any;
  endpoint: string;
}
export type QueryParamValue = string | string[] | number | number[] | boolean;
export type QueryParams = Record<string, QueryParamValue>;
export interface SendRequestPayload extends RequestPayload {
  hydrateToken?: boolean;
  method?: Method;
  queryParams?: QueryParams;
  responseType?: AxiosRequestConfig['responseType'];
  shouldUpdateLatestInteractionTimestamp?: boolean;
}

export interface BaseClientConstructorProps {
  apiKey: string;
  apiSecret: string;
  baseUrl: string;
  bypassGateway: boolean;
  gatewayKey: string;
  nodeEnvironment: NodeEnvironment;
  onApplyCurrencyTypeId: (queryParams: QueryParams, endpoint: string) => QueryParams | undefined;
  onHydrateToken?: () => Promise<void>;
  onUpdateLatestInteractionTimestamp: () => void;
  shouldUseAuthHeader?: boolean;
}

const nowInSeconds = () => Math.floor(Date.now() / 1000);

const stringifyQueryParams = <T extends QueryParams>(queryParams: T) => {
  let queryString = '';
  const keys = Object.keys(queryParams);

  // make an array of [[k,v], [k,v]]
  const keyValuePairs = keys.reduce<string[][]>((acc, k) => {
      const value = queryParams[k];
      if (Array.isArray(value)) {
        acc.push(...value.map((v: number | string) => [k, String(v)]));
      } else if (value !== undefined && value !== null) {
        acc.push([k, String(value)]);
      }

      return acc;
    }, []);

  // add each keyValue pair to the query string
  keyValuePairs.forEach(([key, value], index) => {
    if (value != null) {
      const prefix = index === 0 ? '' : '&';
      const val = encodeURIComponent(value);
      const keyValPair = `${prefix}${key}=${val}`;
      queryString += keyValPair;
    }
  });

  return queryString;
};

axios.defaults.headers.common['Content-Type'] = 'application/json';

const getCoreUrl = (url: string) => {
  let replacedUrl = url;
  const namespace = 'api/v1/core';

  if (url.includes(namespace)) {
    replacedUrl = url.replace(namespace,'private/api/v1');
  }

  return replacedUrl;
};

export class BaseClient {
  protected apiKey: string;
  protected apiSecret: string;
  protected axios: AxiosStatic;
  protected nodeEnvironment: NodeEnvironment;
  private _baseUrl: string;
  private _bypassGateway: boolean;
  private _gatewayKey: string;
  private _onApplyCurrencyTypeId: (queryParams: QueryParams, endpoint: string) => QueryParams | undefined;
  private _onHydrateToken?: () => Promise<void>;
  private _shouldUseAuthHeader?: boolean;
  private _onUpdateLatestInteractionTimestamp: () => void;

  constructor({
    apiKey,
    apiSecret,
    baseUrl,
    bypassGateway,
    gatewayKey,
    nodeEnvironment,
    onApplyCurrencyTypeId,
    onHydrateToken,
    shouldUseAuthHeader,
    onUpdateLatestInteractionTimestamp,
  }: BaseClientConstructorProps) {
    this.apiKey = apiKey;
    this.apiSecret = apiSecret;
    this.axios = axios;
    this._baseUrl = baseUrl;
    this._bypassGateway = bypassGateway;
    this._gatewayKey = gatewayKey;
    this.nodeEnvironment = nodeEnvironment;
    this._onApplyCurrencyTypeId = onApplyCurrencyTypeId;
    this._onHydrateToken = onHydrateToken;
    this._onUpdateLatestInteractionTimestamp = onUpdateLatestInteractionTimestamp;
    this._shouldUseAuthHeader = shouldUseAuthHeader;

    if (!this._bypassGateway) {
      this.axios.defaults.headers.common['x-api-key'] = this._gatewayKey;
    }
  }

  protected _sendRequest: APIRequest = async ({
    data,
    endpoint,
    hydrateToken = false,
    method = 'GET',
    responseType,
    queryParams = null,
    shouldUpdateLatestInteractionTimestamp = true,
  }) => {
    const requestStart = nowInSeconds();

    if (shouldUpdateLatestInteractionTimestamp) {
      this._onUpdateLatestInteractionTimestamp();
    }

    const queryString = queryParams
      ? `?${stringifyQueryParams(this._onApplyCurrencyTypeId(queryParams, endpoint) ?? {})}`
      : '';

    const url = `${this._baseUrl}${endpoint}${queryString}`;

    try {
      const response: AxiosResponse = await this.axios({
        data,
        method,
        responseType,
        url: this._bypassGateway ? getCoreUrl(url) : url,
        withCredentials: true,
      });

      if (hydrateToken && this._onHydrateToken) {
        await this._onHydrateToken();
      }

      if (this._shouldUseAuthHeader && response?.data?.token) {
        this.axios.defaults.headers.common.Authorization = `Bearer ${response.data.token}`;
      }

      return response;
    } catch (err) {
      const now = nowInSeconds();

      const responseTimeInSeconds = now - requestStart;

      // AWS API Gateway has a limit of 30 seconds,
      // which we cannot control.
      // The likelihood of an API request throwing an error
      // that is between 27 seconds and 30 seconds and is not
      // a gateway timeout is VERY unlikely.
      if (responseTimeInSeconds > 27) {
        // @ts-ignore - suppressing 'err is unknown' here. err should always be an object.
        err.response = new Error('We\'re working on your request. Please check back later.');
        // @ts-ignore - suppressing 'err is unknown' here. err should always be an object.
        err.response.title = 'Heads up';
      }

      // If the API did not respond
      // @ts-ignore - suppressing 'err is unknown' here. err should always be an object.
      if (!err.response) {
        // @ts-ignore - suppressing 'err is unknown' here. err should always be an object.
        err.response = new Error('Looks like something went wrong. Please try that again.');
        // @ts-ignore - suppressing 'err is unknown' here. err should always be an object.
        err.response.title = 'Oops';
      }

      if (this.nodeEnvironment === 'development') {
        // @ts-ignore - suppressing 'err is unknown' here. err should always be an object.
        console.error('error: ', err.response);
      }

      // @ts-ignore - suppressing 'err is unknown' here. err should always be an object.
      throw (err.response);
    }
  };
}
// BaseClient